module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.withdrewModal) ? _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.withdrewModal
    },
    attrs: {
      "id": "withdrew-modal-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        취소\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.withdraw
    }
  }, [_vm._v("\n        탈퇴\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("회원탈퇴")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body-container"
  }, [_c('h5', {
    staticClass: "title-type mt-32"
  }, [_vm._v("탈퇴하시겠습니까?")]), _vm._v(" "), _c('div', {
    staticClass: "text-box-section mt-8"
  }, [_vm._v("\n        회원탈퇴 시 아래 사항을 확인해주세요.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "border-line-box"
  }, [_c('ol', {
    staticClass: "out-notice-list"
  }, [_c('li', [_vm._v("탈퇴 시 해당 아이디의 사용은 불가합니다. 50플러스 포털을 이용하시기 위해서는 다시 회원가입을 진행하셔야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("회원탈퇴 후 개인정보는 개인정보 처리방침에 따라 즉시 폐기됩니다.")]), _vm._v(" "), _c('li', [_vm._v("활동정보(강좌 수강정보, 상담정보, 일자리 정보 등)는 활동확인서 등 증빙자료 출력 등을 위해 유지되며, 활동정보 외 데이터는 탈퇴 시 즉시 폐기되어, 새로 회원가입한 아이디로 연동은 불가합니다.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a14ae46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/WithdrewModal.vue
// module id = 1411
// module chunks = 6